module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src023959432/src/github.com/GipsyBot/gipsy-webapp/node_modules/babel-runtime/regenerator/index.js
// module id = 10
// module chunks = 0